import { Controller, useFormContext } from 'react-hook-form';

import { TextFieldProps } from '@mui/material/TextField';

import PhoneNumberInput from '../country-code-selector/country-code-selector';

// ----------------------------------------------------------------------

type Props = TextFieldProps & {
  name: string;
};

export default function RHFCountryCodeSelector({ name, helperText, type, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <PhoneNumberInput
          {...other}
          value={field.value}
          onChange={(value) => {
            field.onChange(value);
          }}
          label={other.label}
          required={other.required}
          error={!!error}
        />
      )}
    />
  );
}
